import type { ReactElement } from "react";

import { SearchResultsTable } from "../SearchResultsTable/SearchResultsTable";

import type { SearchResultsTrialTableProps } from "./SearchResultsTrialTable";
import { SearchResultsTrialTable } from "./SearchResultsTrialTable";

type Props<T extends object> = SearchResultsTrialTableProps<T> & {
    isTrial: boolean;
};

export const SearchResultsTableWithTrialHook = <T extends object>({
    isTrial,
    trialHookProps,
    ...tableProps
}: Props<T>): ReactElement => {
    if (isTrial) {
        return (
            <SearchResultsTrialTable<T>
                {...tableProps}
                trialHookProps={trialHookProps}
            />
        );
    }

    return <SearchResultsTable<T> {...tableProps} />;
};
